export const LIQUID_ASSET_GROUPS = [
  { key: 'bank_accounts',    label: 'Bank Accounts' },
  { key: 'cash_equivalents', label: 'Cash Equivalents' },
  { key: 'stocks_securities', label: 'Stocks / Securities' },
]

export const OTHER_ASSET_GROUPS = [
  { key: 'vehicles',           label: 'Vehicles' },
  { key: 'business_interests', label: 'Business Interests' },
]
